import React, { useState, useEffect, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import DropdownCountry from "./DropdownCountry";
import * as styles from "./styles/select.module.scss";
import { img_chevron_down } from "designsystem/assets/img_icons";
import { Country } from "../../../../types/filter-link-card";

type SelectCountryProp = {
  uniqueCountries?: Country[];
  selectedCountry?: string | null;
  handleCountryChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  label?: string;
  divider?: boolean;
  className?: string;
};

const SelectCountry: React.FC<SelectCountryProp> = ({
  uniqueCountries,
  selectedCountry,
  handleCountryChange,
  label,
  divider = false // Set default value for divider prop
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRaf = useRef<HTMLDivElement>(null);
  const isSelectedCountry = !!selectedCountry;

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  });

  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleOptionClick = (country: string) => {
    const event = {
      target: {
        value: country
      }
    } as React.ChangeEvent<HTMLSelectElement>;

    if (handleCountryChange) {
      handleCountryChange(event);
    }
    setIsOpen(false);
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (
      wrapperRaf.current &&
      !wrapperRaf.current.contains(event.target as Node)
    ) {
      setIsOpen(false);
    }
  };

  return (
    <div className="relative" ref={wrapperRaf}>
      <motion.div className={`relative sm:w-auto w-[16vw] xxl:w-[250px]`}>
        <label className="absolute tracking-wide z-10 text-nexi-colorPalette-blue-40 text-micro font-regular mb-2 pl-4 pt-2">
          {isSelectedCountry ? label : ""}
        </label>
        <button
          type="button"
          className={`relative flex justify-between items-center appearance-none w-fill-available h-full px-4 pt-6 pb-3 rounded leading-tight focus:outline-none focus:shadow-outline font-regular text-medium text-nexi-colorPalette-neutral-20 bg-nexi-colorPalette-neutral-92 bg-opacity-10 hover:bg-nexi-colorPalette-blue-102 focus:bg-nexi-colorPalette-blue-103 ${
            divider ? styles.divider : ""
          } rounded-button-square overflow-hidden ${styles}`}
          onClick={toggleDropdown}
        >
          {isSelectedCountry ? (
            <span>{selectedCountry}</span>
          ) : (
            <span className=" text-nexi-colorPalette-neutral-50 tracking-default leading-6 -mt-2">
              {label}
            </span>
          )}

          <img
            src={img_chevron_down}
            alt={`chevron-down select country`}
            className={
              `${styles.arrow} ${styles.arrowAnimation}` +
              (isOpen ? ` ${styles.arrowRotated}` : "") +
              (!isSelectedCountry ? " -mt-2" : "")
              // isOpen
              //   ? `${styles.arrow} ${styles.arrowAnimation} ${styles.arrowRotated}`
              //   : `${styles.arrow} ${styles.arrowAnimation}`
            }
          />
        </button>
      </motion.div>
      <AnimatePresence>
        {isOpen && (
          <DropdownCountry
            uniqueCountries={uniqueCountries}
            handleCountryChange={handleOptionClick}
            setIsOpen={setIsOpen}
          />
        )}
      </AnimatePresence>
    </div>
  );
};

export default SelectCountry;
